import { Flyout, FlyoutTrigger } from '@zambezi/sdk/flyout';
import classNames from 'classnames';
import React from 'react';
import './Tooltip.scss';

type ShowOn = 'click' | 'hover' | 'focus';

export interface TooltipProps {
  showOn?: ShowOn[];
  content: string | React.ReactNode | React.ReactNode[];
  children?: React.ReactNode | React.ReactNode[];
  withCloseButton?: boolean;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  invert?: boolean;
}

const Tooltip = ({
  children,
  content,
  showOn = ['click', 'hover'],
  withCloseButton = false,
  invert,
  buttonProps = {}
}: TooltipProps) => {
  const { className, ...rest } = buttonProps;
  return (
    <FlyoutTrigger
      showOn={showOn}
      position={{
        direction: 'bottom',
        align: 'left',
        // offsets the arrow a little so it lines up with the icon
        offset: 4
      }}
      arrowAlign="end"
      flyout={
        <Flyout
          iconProps={{ name: 'core-flyout-close', title: 'Close' }}
          withCloseButton={withCloseButton}
          className="mss-tooltip"
        >
          {content}
        </Flyout>
      }
    >
      <button
        className={classNames(
          'mss-tooltip-trigger',
          {
            'mss-tooltip-trigger--invert': invert
          },
          className
        )}
        type="button"
        {...rest}
      >
        {children}
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9ZM1.17387 8.99995C1.17387 4.67772 4.67772 1.17387 8.99995 1.17387C13.3222 1.17387 16.826 4.67772 16.826 8.99995C16.826 13.3222 13.3222 16.826 8.99995 16.826C4.67772 16.826 1.17387 13.3222 1.17387 8.99995ZM8.99994 6.68567C8.61423 6.68567 8.22852 7.07138 8.22852 7.4571V12.8571C8.22852 13.2428 8.61423 13.6285 8.99994 13.6285C9.38566 13.6285 9.77137 13.2428 9.77137 12.8571V7.58567C9.77137 7.07138 9.38566 6.68567 8.99994 6.68567ZM8.22852 4.49994C8.22852 4.11423 8.61423 3.72852 8.99994 3.72852C9.38566 3.72852 9.77137 4.11423 9.77137 4.49994V5.27137C9.77137 5.65709 9.38566 6.0428 8.99994 6.0428C8.61423 6.0428 8.22852 5.65709 8.22852 5.27137V4.49994Z"
          />
        </svg>
      </button>
    </FlyoutTrigger>
  );
};

export default Tooltip;
